module.exports = __webpack_public_path__ + "static/hed-section-1-img-5de21b80e5ea52b2c1657079702eaff6.png";